"use strict";
/**
 * @module Services.RemoteServers
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var list_remote_servers_result_1 = require("./../../services/remote-servers/list-remote-servers-result");
var read_remote_server_1 = require("./../../services/remote-servers/read-remote-server");
/**
 * Serialiser for {@link ListRemoteServersResult}
 */
var ListRemoteServersResultSerialiserClass = /** @class */ (function (_super) {
    __extends(ListRemoteServersResultSerialiserClass, _super);
    function ListRemoteServersResultSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read a {@link ListRemoteServersResult} from the stream
     *
     * @param bis  the input stream
     * @return     the {@link ListRemoteServersResult} that was read
     */
    ListRemoteServersResultSerialiserClass.prototype.read = function (bis) {
        var result = Codec.readCollection(bis, read_remote_server_1.readRemoteServer);
        return new list_remote_servers_result_1.ListRemoteServersResult(result);
    };
    return ListRemoteServersResultSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.ListRemoteServersResultSerialiserClass = ListRemoteServersResultSerialiserClass;
/**
 * The {@link ListRemoteServersResultSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.ListRemoteServersResultSerialiser = new ListRemoteServersResultSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/remote-servers/list-remote-servers-result-serialiser.js
// module id = 1989
// module chunks = 1